<template>
  <div class="phone-abnormal" v-wechat-title="$route.meta.title">
    <header v-if="!isAPP">
      <div class="left" @click="goBack">
        <img src="../../../image/arrows.png" />
      </div>
      <div class="text">更换手机号码</div>
    </header>
    <div class="icon">
      <img src="../../../image/abnormal.png" alt />
    </div>
    <div class="character">
      <span>您的账号存在异常风险，请联系客服解除风险后更换手机号码。</span>
    </div>
    <div class="btn">
      <button @click="accomplish">完成</button>
    </div>
  </div>
</template>

<script>
import { app } from '../../../util/platform'
import CONSTANT from '../../../constant'
import cookie from '../../../lib/cookie'
import { getHostName } from '../../../util/function'
import setDocumentTitle from '@util/document-title'
import userManager from '@util/userManager'

export default {
  data() {
    return {
      phoneNum: userManager.getMobile(),
    }
  },
  methods: {
    goBack() {
      this.$router.push('/login/user/change_phone')
    },
    accomplish() {
      const code = cookie(CONSTANT.COOKIE_KAOP_OPERATION_CODE)
      location.href = `${getHostName()}/ka/${code}/user?orderStatus=999`
    },
  },
  computed: {
    isAPP() {
      this.className2 = ''
      return app.isMZMall()
    },
  },
  mounted() {
    setDocumentTitle('更换手机号码')
  },
}
</script>

<style lang="less">
.phone-abnormal {
  header {
    width: 100%;
    height: 44px;
    position: relative;
    background-color: #fff;
    border-bottom: 0.5px solid rgb(237, 237, 237);

    .left {
      width: 44px;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        display: block;
        width: 11px;
        height: 19px;
      }
    }
    .text {
      width: 103px;
      height: 24px;
      position: absolute;
      top: 10px;
      left: 136px;
      text-align: center;
      line-height: 24px;
      font-size: 17px;
      color: rgb(25, 26, 27);
    }
  }
  .icon {
    width: 100%;
    height: 81px;
    display: flex;
    justify-content: center;
    margin-top: 57px;
    img {
      width: 84px;
      height: 84px;
    }
  }
  .character {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    margin-top: 57px;
    span {
      width: 244px;
      height: 40px;
      font-size: 13px;
      text-align: center;
      color: rgb(121, 125, 130);
    }
  }
  .btn {
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: center;
    margin-top: 81px;
    button {
      width: 300px;
      height: 100%;
      border-radius: 4px;
      background-color: rgb(192, 49, 49);
      color: #fff;
      font-size: 15px;
      border: 1px solid transparent; //自定义边框
      outline: none; //消除默认点击蓝色边框效果
    }
  }
}
</style>
